import * as React from 'react';
import { ServiceSummary } from '../../../features/service-summary';
const Aeroexpress = ({ onServiceDelete }) => {
    return (React.createElement(ServiceSummary, { serviceType: "Aeroexpress", onDelete: onServiceDelete }, content => React.createElement(React.Fragment, null, content)));
};
export default Aeroexpress;
